import { render } from "./Index.vue?vue&type=template&id=23543608"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23543608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23543608', __exports__)) {
    api.reload('23543608', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=23543608", () => {
    api.rerender('23543608', render)
  })

}


export default __exports__